var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.272,
    height: 74.919,
    viewBox: "0 0 75.272 74.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system-integration_8940940",
    transform: "translate(-1 -1.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(10.644 57.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M11.787,49.551A4.249,4.249,0,0,0,9.2,53.432a4.091,4.091,0,0,0,4.116,4.116,4.167,4.167,0,0,0,4.116-4.116A4.057,4.057,0,0,0,11.787,49.551Z",
    transform: "translate(-9.2 -49.21)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(11.115 10.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M13.716,17.533A4.13,4.13,0,0,0,17.6,11.887,4.073,4.073,0,0,0,13.716,9.3a4.116,4.116,0,0,0,0,8.233Z",
    transform: "translate(-9.6 -9.3)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(1 34.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M9.351,33.616a4.176,4.176,0,0,0-8.351,0,4.091,4.091,0,0,0,4.116,4.116A4.116,4.116,0,0,0,9.351,33.616Z",
    transform: "translate(-1 -29.5)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(34.52 67.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M33.616,57.8A4.091,4.091,0,0,0,29.5,61.916,4.116,4.116,0,1,0,33.616,57.8Z",
    transform: "translate(-29.5 -57.8)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(34.632 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M33.6,9.451a4.193,4.193,0,0,0,4.234-4.116A4.268,4.268,0,0,0,33.717,1.1,4.091,4.091,0,0,0,29.6,5.216,3.954,3.954,0,0,0,33.6,9.451Z",
    transform: "translate(-29.595 -1.1)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(57.807 58.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M53.416,49.5a4.116,4.116,0,0,0,0,8.233,4.091,4.091,0,0,0,4.116-4.116A4.167,4.167,0,0,0,53.416,49.5Z",
    transform: "translate(-49.3 -49.5)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(58.376 11.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M53.8,17.833a4.271,4.271,0,0,0,4.234-4.116,4.116,4.116,0,1,0-8.233,0A3.922,3.922,0,0,0,53.8,17.833Z",
    transform: "translate(-49.784 -9.6)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(68.039 34.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M62.116,29.5a4.116,4.116,0,1,0,0,8.233,4.116,4.116,0,0,0,0-8.233Z",
    transform: "translate(-58 -29.5)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(17.701 17.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M52.013,45.262a21.207,21.207,0,0,0,1.882-4.469l3.176-.118A1.265,1.265,0,0,0,58.246,39.5V33.148a1.179,1.179,0,0,0-1.176-1.176l-2.117-.118H53.895a17.035,17.035,0,0,0-1.882-4.469l2.117-2.352a1.137,1.137,0,0,0,0-1.647l-4.469-4.469a1.137,1.137,0,0,0-1.647,0l-2.352,2.117a21.207,21.207,0,0,0-4.469-1.882l-.118-3.176A1.265,1.265,0,0,0,39.9,14.8H33.548a1.179,1.179,0,0,0-1.176,1.176l-.118,3.176a16.444,16.444,0,0,0-4.469,1.882l-2.352-2.117a1.137,1.137,0,0,0-1.647,0l-4.469,4.352a1.137,1.137,0,0,0,0,1.647l2.117,2.352a21.207,21.207,0,0,0-1.882,4.469l-3.176.118A1.265,1.265,0,0,0,15.2,33.03v6.351a1.179,1.179,0,0,0,1.176,1.176l3.176.118a16.444,16.444,0,0,0,1.882,4.469L19.316,47.5a1.137,1.137,0,0,0,0,1.647l4.469,4.469a1.137,1.137,0,0,0,1.647,0L27.785,51.5a21.207,21.207,0,0,0,4.469,1.882l.118,3.176a1.265,1.265,0,0,0,1.176,1.176H39.9a1.179,1.179,0,0,0,1.176-1.176l.118-3.176A17.035,17.035,0,0,0,45.662,51.5l2.352,2.117a1.137,1.137,0,0,0,1.647,0l4.469-4.469a1.137,1.137,0,0,0,0-1.647ZM36.723,43.5a7.292,7.292,0,1,1,7.292-7.292A7.329,7.329,0,0,1,36.723,43.5Z",
    transform: "translate(-15.2 -14.8)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(20.759 6.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M18.741,12.7,30.267,8.117A6.859,6.859,0,0,1,29.326,6L17.8,10.587c.235.353.353.706.588,1.059a11.1,11.1,0,0,1,.353,1.059Z",
    transform: "translate(-17.8 -6)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(63.57 20.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M54.2,18.623l4.7,11.761a4.357,4.357,0,0,1,2.117-.941L56.317,17.8A8.833,8.833,0,0,1,54.2,18.623Z",
    transform: "translate(-54.2 -17.8)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(44.046 6.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M50.42,10.857,38.541,5.8A5.354,5.354,0,0,1,37.6,8.035l11.879,5.057a7.516,7.516,0,0,1,.941-2.235Z",
    transform: "translate(-37.6 -5.8)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(20.171 63.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M17.3,56.217l12.114,5.175a5.7,5.7,0,0,1,.823-2.117l-12-5.175A8.355,8.355,0,0,1,17.3,56.217Z",
    transform: "translate(-17.3 -54.1)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(63.452 44.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M54.1,49.479a5.812,5.812,0,0,1,2.117.941l5.057-11.879a5.812,5.812,0,0,1-2.117-.941Z",
    transform: "translate(-54.1 -37.6)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(44.046 63.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M37.6,59a6.859,6.859,0,0,1,.941,2.117l11.526-4.7a4.9,4.9,0,0,1-.941-2.117Z",
    transform: "translate(-37.6 -54.3)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(6.763 44.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M11.428,49.479c.353-.118.706-.235,1.176-.353L8.017,37.6a4.9,4.9,0,0,1-2.117.941l4.587,11.408a6.984,6.984,0,0,1,.941-.47Z",
    transform: "translate(-5.9 -37.6)",
    fill: "#7b7bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(6.528 20.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M12.992,18.341a4.357,4.357,0,0,1-2.117-.941L5.7,29.4a7.516,7.516,0,0,1,2.235.941Z",
    transform: "translate(-5.7 -17.4)",
    fill: "#7b7bff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/SI.fbe91d194148b4a8fd382f9623937014.svg";
export { ForwardRef as ReactComponent };